import { Icon } from '@vds/icons';
import { Body, Micro, Title } from '@vds/typography';
import React, { useEffect } from 'react';
import { ButtonIcon } from '@vds/button-icons';
import './OffersCard.scss';
import { useTranslation } from 'react-i18next';
import { height } from '@material-ui/system';
import { navigateUsingLanguage } from '../../../utility/utils';
const OffersCardComponent = (props) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    console.log('carddata', props);
  }, []);
  const modalClick = (event) => {
    if (!event) {
      props.modal(event);
    }
  };
  const handleClick = () => {
    console.log("offers card click");
  };
  return (
    <article id="ellipsisText" className={(!props.data?.bg ? '' : props.data?.bg) + ' tile-container offers-card offers-card-small pa-4X border-box'} onClick={() => {navigateUsingLanguage(`/course-details/${props?.data?.id}`)}}>
        <div class="body-sm pb-4X sm-pb-3X">
            <b class="color-secondary">{props?.data?.vendor}</b>
        </div>
        <div class="title-sm pb-3X sm-pb-3X">{props?.data?.title}</div>
        <div className="tag bold body-sm " style={{backgroundColor: props?.data?.catBg ? props?.data?.catBg :props?.data?.categoryColor}}>{props?.data?.category}</div>
        <div class="flex-apart  cta">
            <div class="flex-apart" style={{color: props?.data?.statusColor}}>
                <i _ngcontent-ejj-c22="" class={`fs-3X icon ${props?.data?.statusIcon} onedicon`}></i>
                <span class="ml-1X micro bold">{t(`${props?.data?.statusText}`)}</span>
            </div>
            {/* <i class="fs-4X icon-right-arrow onedicon mr-6X"></i> */}
            <div>
              <ButtonIcon
                role="link"
                tabIndex={0}
                ariaLabel={`${props?.data?.ariaLabel ? props?.data?.ariaLabel?.replace('undefined',''):""} ${props?.data?.title}`}
                kind="ghost"
                size="large"
                renderIcon={(props) => <Icon name="right-arrow" {...props}  />}
                onClick={() => {navigateUsingLanguage(`/course-details/${props?.data?.id}`)}}
              />
            </div>
        </div>
      </article>

  );
};

export default OffersCardComponent;
